document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const drawer = document.querySelector('.su-mobile-drawer');
  const overlay = document.querySelector('.su-menu-overlay');
  const openButton = document.querySelector('[data-su-menu-open]');
  const closeButton = drawer?.querySelector('button[data-su-menu-close]');
  const setMenu = (open) => {
    drawer?.classList.toggle('is-open', open);
    overlay?.classList.toggle('is-open', open);
    drawer?.setAttribute('aria-hidden', String(!open));
    openButton?.setAttribute('aria-expanded', String(open));
    body.style.overflow = open ? 'hidden' : '';
    if (open) closeButton?.focus();
  };
  openButton?.addEventListener('click', () => setMenu(true));
  document.querySelectorAll('[data-su-menu-close]').forEach((button) => button.addEventListener('click', () => { setMenu(false); openButton?.focus(); }));
  drawer?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setMenu(false); });

  document.querySelectorAll('[data-su-announcement]').forEach((bar) => {
    const messages = [...bar.querySelectorAll('.su-announcement__messages p')];
    if (messages.length < 2) return;
    let index = 0;
    let timer;
    const show = (next) => {
      index = (next + messages.length) % messages.length;
      messages.forEach((message, i) => message.classList.toggle('is-active', i === index));
    };
    const play = () => {
      window.clearInterval(timer);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = window.setInterval(() => show(index + 1), Number(bar.dataset.speed) || 6000);
    };
    bar.querySelector('[data-su-announcement-prev]')?.addEventListener('click', () => { show(index - 1); play(); });
    bar.querySelector('[data-su-announcement-next]')?.addEventListener('click', () => { show(index + 1); play(); });
    play();
  });

  document.querySelectorAll('[data-su-hero]').forEach((hero) => {
    const slides = [...hero.querySelectorAll('.su-hero__slide')];
    const counter = hero.querySelector('[data-su-hero-count]');
    if (slides.length < 2) return;
    let index = 0;
    let timer;
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
    };
    const play = () => {
      window.clearInterval(timer);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = window.setInterval(() => show(index + 1), Number(hero.dataset.speed) || 7000);
    };
    hero.querySelector('[data-su-hero-prev]')?.addEventListener('click', () => { show(index - 1); play(); });
    hero.querySelector('[data-su-hero-next]')?.addEventListener('click', () => { show(index + 1); play(); });
    hero.addEventListener('mouseenter', () => window.clearInterval(timer));
    hero.addEventListener('mouseleave', play);
    play();
  });
});
